(function () {
  var root = document.getElementById('nlp');
  if (!root) return;

  var dlg = root.querySelector('.nlp-dialog');
  var tab = document.getElementById('nlp-tab');
  var KEY = 'yeha_nlp';
  var SEEN = 'yeha_nlp_seen';
  var days = parseInt(root.getAttribute('data-days'), 10) || 30;
  var repeat = root.getAttribute('data-repeat') === 'true';
  var belowHeader = root.getAttribute('data-below-header') === 'true';
  var isMobile = window.matchMedia('(max-width: 767.98px)').matches;
  var popAllowed = root.getAttribute(isMobile ? 'data-pop-m' : 'data-pop-d') === 'true';
  var tabOn = root.getAttribute('data-tab') === 'true';
  var lastFocus = null;
  var timer = null;

  function getCookie() {
    var m = document.cookie.match(/(?:^|; )yeha_nlp=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setCookie(v, n) {
    var exp = new Date(Date.now() + n * 864e5).toUTCString();
    document.cookie = KEY + '=' + encodeURIComponent(v) + '; expires=' + exp + '; path=/; SameSite=Lax';
  }

  /* "Seen" = the visitor already got the popup or the tab earlier in this visit: next pages are not delayed */
  var returning = false;
  try { returning = sessionStorage.getItem(SEEN) === '1'; } catch (e) {}
  function markSeen() { try { sessionStorage.setItem(SEEN, '1'); } catch (e) {} }

  /* Bottom edge of the header (and announcement bar) that is visible at the top of the screen.
     The popup and overlay start there, so the header is never covered. 0 when the header has scrolled away. */
  function headerBottom() {
    var max = 0;
    var els = document.querySelectorAll('#header-component, #header-group, #shopify-section-header, #shopify-section-header-2, #shopify-section-announcement-bar, header, .site-header, .header, .header-wrapper');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (root.contains(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.bottom <= 0 || r.top > 120 || r.height > window.innerHeight * 0.4) continue;
      if (r.bottom > max) max = r.bottom;
    }
    return Math.round(max);
  }
  function setTop() {
    root.style.setProperty('--nlp-top', (belowHeader ? headerBottom() : 0) + 'px');
  }
  window.addEventListener('resize', function () { if (root.classList.contains('is-open')) setTop(); });

  function isOpen() { return root.classList.contains('is-open'); }
  function showTab(on) { if (tab) tab.classList.toggle('is-on', !!on && tabOn); }

  function open() {
    if (isOpen()) return;
    if (document.querySelector('dialog[open]')) { timer = setTimeout(open, 4000); return; }
    lastFocus = document.activeElement;
    clearTimeout(timer);
    returning = true;
    markSeen();
    setTop();
    root.classList.add('is-open');
    document.documentElement.classList.add('nlp-lock');
    showTab(false);
    /* On phones do not focus the email field: the keyboard would cover the sheet */
    var f = (!isMobile && root.querySelector('.nlp-email')) || dlg;
    setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 60);
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('nlp-lock');
    var st = getCookie();
    /* Only when "show again on every page" is off is the closed state remembered between pages */
    if (!repeat && st !== 'done' && st !== 'tabx') setCookie('closed', days);
    st = getCookie();
    showTab(st !== 'done' && st !== 'tabx');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nlp-close], [data-nlp-open], [data-nlp-tabx]');
    if (!t) return;
    if (t.hasAttribute('data-nlp-close')) { close(); }
    else if (t.hasAttribute('data-nlp-open')) { open(); }
    else if (t.hasAttribute('data-nlp-tabx')) { setCookie('tabx', days); showTab(false); }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.slice.call(dlg.querySelectorAll('button, a[href], input, select, textarea')).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Links in the consent text open in a new tab so the popup (and the visitor's email) stays */
  var links = root.querySelectorAll('.nlp-consent a');
  for (var i = 0; i < links.length; i++) { links[i].target = '_blank'; links[i].rel = 'noopener'; }

  /* Preference radio becomes a customer tag, e.g. pref-women */
  var form = document.getElementById('nlp-form');
  if (form) {
    form.addEventListener('submit', function () {
      var tags = document.getElementById('nlp-tags');
      var r = form.querySelector('input[name="nlp_pref"]:checked');
      if (tags && r) {
        var slug = r.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (slug) tags.value = 'prospect,newsletter,pref-' + slug;
      }
    });
  }

  /* Coordinate native inline email signup with this popup.
     This element is rendered by Horizon only after its customer form succeeds.
     Do not treat a submit click or a URL parameter as proof of signup. */
  var inlineSignupSuccess = document.querySelector(
    '.email-signup-block [id^="Email-signup__message-success-"]'
  );
  if (inlineSignupSuccess) {
    setCookie('done', 365);
    markSeen();
    showTab(false);
    /* Keep the popup editable in the theme editor, but suppress it on the storefront. */
    if (root.getAttribute('data-design') !== 'true') return;
  }

  /* Signed up, form error, or theme editor: always open */
  if (root.querySelector('[data-nlp-success]')) { setCookie('done', 365); open(); return; }
  if (root.querySelector('[data-nlp-error]')) { open(); return; }
  if (root.getAttribute('data-design') === 'true') { open(); return; }

  var state = getCookie();
  if (state === 'done' || state === 'tabx') return;
  if (!repeat && state === 'closed') { markSeen(); showTab(true); return; }

  /* Page or device where the popup is not allowed: floating tab only */
  if (!popAllowed) { markSeen(); showTab(true); return; }

  /* Already seen during this visit: keep the manual tab, do not auto-open again. */
  if (returning) {
    showTab(true);
    return;
  }

  /* First page of the visit: popup after the delay (counted from page load) and, on phones, after some scrolling */
  function schedule() {
    var wait = (parseFloat(root.getAttribute('data-delay')) || 0) * 1000;
    var pct = isMobile ? (parseFloat(root.getAttribute('data-scroll')) || 0) : 0;
    var timeDone = false;

    function scrolled() {
      if (pct <= 0) return true;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      return h <= 0 || (window.pageYOffset / h) * 100 >= pct;
    }
    function check() {
      if (returning) {
        window.removeEventListener('scroll', check);
        return;
      }
      if (timeDone && scrolled()) {
        window.removeEventListener('scroll', check);
        open();
      }
    }
    if (pct > 0) window.addEventListener('scroll', check, { passive: true });
    timer = setTimeout(function () { timeDone = true; check(); }, wait);
  }
  if (document.readyState === 'complete') { schedule(); }
  else { window.addEventListener('load', schedule, { once: true }); }
})();
